export default "__VITE_ASSET__lbV4Pd_o__"